import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../Layout/PageHeader'
import { useState } from 'react';
import Table, { Column } from '../../../Components/Tables/Table';
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from 'react-bootstrap-icons';
import { cyclecountoverviewnewlist, cyclecountoverviewinprogresslist, cyclecountoverviewpendingreviewlist, cyclecountoverviewcompletedlist } from '../../../Data/testData';
import Tabs from '../../../Shared/Tab/Tab';
import { cycleCountDropDownData } from "../../../Data/dropdownDataList";
import CommonModal from "../../../Components/Modals/CommonModal";
import AssignToUserLayout from "../../../Layout/AssignToUserLayout";
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";

const CycleCountOverview = () => {
    const pageName = "Cycle Count";
    const navigation = useNavigate();
    const [showModalForImportAndExport, setShowModalForImportAndExport] =
    useState({
      importModal: false,
      exportModal: false,
    });

    
    const [showRowClicked, setShowRowClicked] = useState(false);
    const handelDetailScreenAction = (data: any) => {
        navigation(`/inventory/counts/cycle-count`)
    };
    const handelInactiveAction = (data: any) => { setShow(true); };
    const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
    const handleSelectedRowsChange = (newSelectedRows: Set<number>) => {
        setSelectedRows(newSelectedRows);
    };
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleShow = () => setShow(!show);
    const handleClose = () => setShow(false);

    const handleRowClick = (data: any) => {
        if (showRowClicked == false) {
            navigation(
                `/inventory/counts/cycle-count/details/${data.cycle_count}`
            );
        }
    };
    const handelEditAction = (data: any) => { };
    const columns: Column[] = [
        {
            name: "Cycle Count#",
            selector: (row: { cycle_count: string }) => (
                <span onClick={() => handleRowClick(row)} className="cursor-pointer text-primary ms-1" >
                    {row.cycle_count}
                </span>
            ),
            enableSorting: true
        },
        {
            name: "Count Type ",
            selector: (row: { count_type: string }) => row.count_type,
        },
        {
            name: "Counted Date",
            selector: (row: { counted_date: string }) => row.counted_date,
        },
        {
            name: "Recount",
            selector: (row: { recount: string }) => row.recount,
        },
        {
            name: "Status",
            selector: (row: { status: string }) => {
                return row.status === "new" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-blue">
                        New
                    </span>
                ) : row.status === "pending_review" ? (
                    <span className="badge text asn-overview-status asn-overview-status-border-red">
                        Pending Review
                    </span>
                ) : row.status === "complete" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-green">
                        Completed
                    </span>
                ) : row.status === "in progress" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-yellow">
                        In Progress
                    </span>
                ) : (
                    <></>
                );
            },
        },
        {
            name: (
                <>
                    <ArrowLeftRight className="me-2" /> <PlusCircle />
                </>
            ),
            selector: (row: any) => (
                <>
                    <span
                        className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => setShowRowClicked(true)}
                    >
                        <ThreeDotsVertical />
                    </span>
                    <ul className="dropdown-menu action-items">
                        <li
                            className="cursor-pointer mt-2 fs-14 fw-medium"
                            onClick={() => handelInactiveAction(row)}
                        >
                            Assign
                        </li>
                        <li
                            className="cursor-pointer  mt-2 fs-14 fw-medium"
                            onClick={() => handelDetailScreenAction(row)}
                        >
                            Detail Screen
                        </li>
                        <li
                            className="cursor-pointer  mt-2 fs-14 fw-medium"
                            onClick={() => handelEditAction(row)}
                        >
                            Edit
                        </li>
                    </ul>
                </>
            ),
        },
    ];
    const onCurrentPageChange = (page: number) => {
        // Handle page change here if needed
        console.log('Page changed to:', page);
      };

    const tabs = [
        {
            order: 0,
            label: "New | " + cyclecountoverviewnewlist.length,
            content: (
                <div className='mt-2'>
                    <Table
                        columns={columns}
                        data={cyclecountoverviewnewlist}
                         pagination={{
          recordsPerPage: 15,
          totalRecords: cyclecountoverviewnewlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
                        CheckboxStatus={true} enableSorting={true}
                        onSelectedRowsChange={handleSelectedRowsChange}
                    />
                </div>
            ),
            visibility: true,
            status: true,
        },
        {
            order: 1,
            label: "In Progress | " + cyclecountoverviewinprogresslist.length,
            content: (
                <div className='mt-2'>
                <Table
                    columns={columns}
                    data={cyclecountoverviewinprogresslist}
                     pagination={{
          recordsPerPage: 15,
          totalRecords: cyclecountoverviewinprogresslist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
                    enableSorting={true}
                    CheckboxStatus={true}
                    onSelectedRowsChange={handleSelectedRowsChange}
                />
                </div>
            ),
            visibility: true,
            status: false,
        },
        {
            order: 2,
            label: "Pending Review | " + cyclecountoverviewpendingreviewlist.length,
            content: (
                <div className='mt-2'>
                <Table
                    columns={columns}
                    data={cyclecountoverviewpendingreviewlist}
                     pagination={{
          recordsPerPage: 15,
          totalRecords: cyclecountoverviewpendingreviewlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
                    enableSorting={true}
                    CheckboxStatus={true}
                    onSelectedRowsChange={handleSelectedRowsChange}
                />
                </div>
            ),
            visibility: true,
            status: false,
        },
        {
            order: 3,
            label: "Completed | " + cyclecountoverviewcompletedlist.length,
            content: <div className='mt-2'>
                <Table
                    columns={columns}
                    data={cyclecountoverviewcompletedlist}
                     pagination={{
          recordsPerPage: 15,
          totalRecords: cyclecountoverviewcompletedlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
                    enableSorting={true}
                    CheckboxStatus={true}
                    onSelectedRowsChange={handleSelectedRowsChange}
                />
            </div>
            ,
            visibility: true,
            status: true,
        },
    ];
    return (
        <>
            <PageHeader
                name={selectedRows.size > 0 ? "Assign" : "Create"}
                isShowUpload={true}
                addUrl={selectedRows.size > 0 ? undefined  : "/inventory/counts/create"}
                isDropdown={selectedRows.size > 0 ? false : true}
                dropDownData={cycleCountDropDownData}
                onAddClick={() => {
                    if (selectedRows.size > 0) {
                        handleShow();
                    }
                }}
                setShowModalForImportAndExport={setShowModalForImportAndExport}
                showModalForImportAndExport={showModalForImportAndExport}
            />
            <div className="clearfix"></div>
            <h5 className="text-start mt-1 mb-3">{pageName}</h5>
            <div >
                <Tabs tabs={tabs} isCheckbox={false} />
            </div>
            <div className="inbound-CheckIn-Table-Main-Div"></div>
            <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
            <CommonModal
                handleClose={() => setShow(false)}
                show={show}
                heading="Assign To"
                content={<AssignToUserLayout handleClose={handleShow} />}
                modalSize="modal-lg"
                footerButtonsActive={false}
                customClassNameForBody=""
                customClassNameForHeader='count-assign-modal-header'
            />
        </>
    )
}

export default CycleCountOverview